import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodListComponent } from './payment-method-list.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PaymentSipButtonModule } from '../payment-sip-button/payment-sip-button.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  declarations: [
    PaymentMethodListComponent
  ],
  exports: [
    PaymentMethodListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    PaymentSipButtonModule
  ]
})
export class PaymentMethodListModule { }
